import React, { useState } from "react";

const AddRoomModal = ({ isOpen, onClose, onSave }) => {
  const [number, setNumber] = useState("");
  const [type, setType] = useState("Standard");

  if (!isOpen) return null;

  const handleSave = () => {
    onSave({
      id: Date.now(),
      number,
      type,
      facilityEquipment: [],
      careEquipment: [],
      beds: [],
    });
    setNumber("");
    setType("Standard");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-11/12 md:w-1/3">
        <h2 className="text-2xl font-bold mb-4">Add Room</h2>
        <input
          type="text"
          placeholder="Room Number"
          value={number}
          onChange={(e) => setNumber(e.target.value)}
          className="w-full border p-2 rounded mb-4"
        />
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="w-full border p-2 rounded mb-4"
        >
          <option value="Standard">Standard</option>
          <option value="Deluxe">Deluxe</option>
        </select>
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => {
              handleSave();
              onClose();
            }}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Save
          </button>
          <button
            onClick={onClose}
            className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddRoomModal;
